<template>
  <div class="aarrow_box mt-5">
    <v-card-text>
      <span>
        <h5 class="accent--text text-center" style="font-size: 20px; font-weight:700"> Growers Settlement Details Report
        </h5>
        <!-- <div>
      <label for="pageSize">Items per Page:</label>
      <select v-model="itemsPerPage" @change="changePageSize" class="text-red">
        <option value="5">5</option>
        <option value="10">10</option>
        <option value="20">20</option>

      </select>
    </div> -->
        <v-spacer>
          </v-spacer>
          <v-flex xs3>
            <v-btn color="primary" @click="exportToExcel" style="margin-top: 10px;">Export to Excel</v-btn>
          </v-flex>
        <br/>
      </span>
      <table class="table table-responsive">
        <thead class="thead">
          <tr>
            <th scope="col">Season</th>
            <th scope="col">Sale</th>
            <th scope="col">Eslip</th>
            <th scope="col">Status</th>
            <th scope="col">Amount</th>
            <th scope="col">Account Number</th>
            <th scope="col">Grower Name</th>
            <th scope="col">Grower Code</th>
            <th scope="col">Error Code</th>
            <th scope="col">Error Description</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in paginatedData" :key="row.id">
            <td>{{ row.season }}</td>
            <td>{{ row.saleNumber }}</td>
            <td>{{ row.eslipNumber }}</td>
            <td>{{ row.status.statusName }}</td>
            <td>{{ row.eslipAmount }}</td>
            <td></td>
            <td>{{ row.organizationName }} </td>
            <td>{{ row.organisationCode }}</td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </v-card-text>
    <div>
      <v-btn @click="prevPage" :disabled="currentPage === 1" > {{ prev }}  Previous</v-btn>
      <span class="ml-2">Page {{ currentPage }} of {{ totalPages }}</span>
      <v-btn @click="nextPage" :disabled="currentPage === totalPages"><span class="ml-2">Next </span> {{ next }}</v-btn>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import * as XLSX from 'xlsx'

export default {
	name: 'PaidUnpaidData',
	data: function () {
		return {
			items: [],
			paginatedFiles: [],
			numberOfLinks: 0,
			page: 1,
			prev: '<<',
			next: '>>',
			payments: [],
			currentPage: 1,
			itemsPerPage: 7,
			// totalData: 100,
			totalItems: 1
		}
	},

	computed: {
		totalPages () {
			return Math.ceil(this.totalItems / this.itemsPerPage)
		},
		paginatedData () {
			const startIndex = (this.currentPage - 1) * this.itemsPerPage
			const endIndex = startIndex + this.itemsPerPage
			return this.payments.slice(startIndex, endIndex)
		}
	},

	mounted () {
		// this.getDataFromApi()
		console.log(this.segmentSelected)
		this.getSettlementGrowersDetails(this.segmentSelected)
	},

	props: {
		segmentSelected: {
			type: String, // Adjust the type based on the actual type of the value you want to pass
			default: null
		}
	},
	methods: {
		getDataFromApi () {
			this.loading = true
			return new Promise((resolve, reject) => {
				const items = this.getAuctionFiles()
				const total = items.length
				setTimeout(() => {
					this.loading = false
					resolve({
						items,
						total
					})
				}, 1000)
			})
		},
		prevPage () {
			if (this.currentPage > 1) {
				this.currentPage--
			}
		},
		nextPage () {
			if (this.currentPage < this.totalPages) {
				this.currentPage++
			}
		},
		changePageSize () {
			this.currentPage = 1 // Reset to the first page when changing page size
			this.loadData()
		},
		// paginationMethod (items, pageNumber, limitPerPage) {
		//   pageNumber = pageNumber - 1
		//   const from = pageNumber * limitPerPage
		//   let to = (pageNumber + 1) * limitPerPage
		//   if (to >= items.length) {
		//     to = items.length
		//   }
		//   return items.slice(from, to)
		// },
		getAuctionFiles () {
			var url = config.serverURI + '/reports/upload/auction/getAll'

			axios.get(url)
				.then(response => {
					this.items = response.data
					this.$emit('updateAuctionFilesCount', this.items.length)
				})
				.catch(error => {
					console.log('error', error.response)
				})
			return this.items
		},
		getSettlementGrowersDetails (event) {
			if ((event !== 'PENDINGSETTLEMENT') && (event !== 'SETTLEDGROWERS') && (event !== 'FAILEDGROWERCHARGES') && (event == 'SETTLEDGROWERCHARGES') && (event !== 'FAILEDGROWERSETTLEMENT')) {
				const id = 40
				const token = localStorage.getItem('token')
				const tokenconfig = { headers: { Authorization: `Bearer ${token}` } }
				const url = config.serverURI + '/reports/findAllPaymentsByStatus'
				axios
					.post(url, { id, tokenconfig })
					.then((response) => {
						this.payments = response.data
						const arr = response.data
						this.totalItems = parseInt(Object.keys(response.data).length)
						this.payments = arr
						console.log('arr:  ====>' + arr)
						return arr
					})
					.catch((error) => {
						// Request failed.
						console.log('error', error.response)
						this.message = error.response.status
						this.snackbar = true
						this.snackbarColor = 'error'
					})
			} else if ((event !== 'PENDINGSETTLEMENT') && (event !== 'SETTLEDGROWERS') && (event === 'FAILEDGROWERCHARGES') && (event !== 'SETTLEDGROWERCHARGES') && (event !== 'FAILEDGROWERSETTLEMENT')) {
				const id = 41
				const token = localStorage.getItem('token')
				const tokenconfig = { headers: { Authorization: `Bearer ${token}` } }
				const url = config.serverURI + '/reports/findAllPaymentsByStatus'
				axios
					.post(url, { id, tokenconfig })
					.then((response) => {
						this.payments = response.data
						const arr = response.data
						this.totalItems = parseInt(Object.keys(response.data).length)
						this.payments = arr
						console.log('arr:  ====>' + arr)
						return arr
					})
					.catch((error) => {
						// Request failed.
						console.log('error', error.response)
						this.message = error.response.status
						this.snackbar = true
						this.snackbarColor = 'error'
					})
			} else if ((event === 'PENDINGSETTLEMENT') && (event !== 'SETTLEDGROWERS') && (event !== 'FAILEDGROWERCHARGES') && (event !== 'SETTLEDGROWERCHARGES') && (event !== 'FAILEDGROWERSETTLEMENT')) {
				const id = 6
				const token = localStorage.getItem('token')
				const tokenconfig = { headers: { Authorization: `Bearer ${token}` } }
				const url = config.serverURI + '/reports/findAllPaymentsByStatus'
				axios
					.post(url, { id, tokenconfig })
					.then((response) => {
						this.payments = response.data
						const arr = response.data
						this.totalItems = parseInt(Object.keys(response.data).length)
						this.payments = arr
						console.log('arr:  ====>' + arr)
						return arr
					})
					.catch((error) => {
						// Request failed.
						console.log('error', error.response)
						this.message = error.response.status
						this.snackbar = true
						this.snackbarColor = 'error'
					})
			} else if ((event !== 'PENDINGSETTLEMENT') && (event !== 'SETTLEDGROWERS') && (event !== 'FAILEDGROWERCHARGES') && (event !== 'SETTLEDGROWERCHARGES') && (event === 'FAILEDGROWERSETTLEMENT')) {
				const id = 39
				const token = localStorage.getItem('token')
				const tokenconfig = { headers: { Authorization: `Bearer ${token}` } }
				const url = config.serverURI + '/reports/findAllPaymentsByStatus'
				axios
					.post(url, { id, tokenconfig })
					.then((response) => {
						this.payments = response.data
						const arr = response.data
						this.totalItems = parseInt(Object.keys(response.data).length)
						this.payments = arr
						console.log('arr:  ====>' + arr)
						return arr
					})
					.catch((error) => {
						// Request failed.
						console.log('error', error.response)
						this.message = error.response.status
						this.snackbar = true
						this.snackbarColor = 'error'
					})
			} else if ((event !== 'PENDINGSETTLEMENT') && (event === 'SETTLEDGROWERS') && (event !== 'FAILEDGROWERCHARGES') && (event !== 'SETTLEDGROWERCHARGES') && (event !== 'FAILEDGROWERSETTLEMENT')) {
				const id = 38
				const token = localStorage.getItem('token')
				const tokenconfig = { headers: { Authorization: `Bearer ${token}` } }
				const url = config.serverURI + '/reports/findAllPaymentsByStatus'
				axios
					.post(url, { id, tokenconfig })
					.then((response) => {
						this.payments = response.data
						const arr = response.data
						this.totalItems = parseInt(Object.keys(response.data).length)
						this.payments = arr
						console.log('arr:  ====>' + arr)
						return arr
					})
					.catch((error) => {
						// Request failed.
						console.log('error', error.response)
						this.message = error.response.status
						this.snackbar = true
						this.snackbarColor = 'error'
					})
			}
		},
		exportToExcel () {
			const exportData = this.payments.map(growerStmt => ({
				Season: growerStmt.season,
				'Sale Number': growerStmt.saleNumber,
				'Eslip Number': growerStmt.eslipNumber,
				status: growerStmt.status.statusName,
				Amount: growerStmt.eslipAmount,
				Account: growerStmt.grower_CODE,
				'Grower Name': growerStmt.organizationName,
				'Grower Code': growerStmt.organisationCode,
				'Error Code': '',
				'Error Description': ''
			}))
			const worksheet = XLSX.utils.json_to_sheet(exportData)
			const workbook = XLSX.utils.book_new()
			XLSX.utils.book_append_sheet(workbook, worksheet, 'SettlementData')
			const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
			this.saveExcelFile(excelBuffer, 'grower_settlement_report.xlsx')
		},
		saveExcelFile (buffer, fileName) {
			const data = new Blob([buffer], { type: 'application/octet-stream' })
			const url = window.URL.createObjectURL(data)
			const a = document.createElement('a')
			a.href = url
			a.download = fileName
			a.click()
			window.URL.revokeObjectURL(url)
		}
	}
}
</script>
<style>
.aarrow_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
  border-radius: 5px;
}

.aarrow_box:after,
.aarrow_box:before {
  bottom: 100%;
  left: 60%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.aarrow_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-bottom-color: #fff;
  border-width: 20px;
  margin-left: -20px;
}

.aarrow_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-bottom-color: #707070;
  border-width: 21px;
  margin-left: -21px;
}</style>
